import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { db } from '../instant';
import { Report } from '../schema';

interface Props {
    report?: Report;
    open: boolean;
    onClose: () => void;
}

export default function DeleteReportDialog(props: Props) {
    const { user } = db.useAuth();

    if (props.report === null) {
        return <></>;
    }

    const deleteAndClose = async () => {
        if (props.report) {
            await db.transact([db.tx.reports[props.report.id].delete()]);

            props.onClose();
        }
    };

    const reportName = props.report?.template?.name || 'Unnamed Report';

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Really delete this report?</DialogTitle>
            <DialogContent>
                <DialogContentText>The report &quot;{reportName}&quot; will be deleted. This action cannot be undone.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button disabled={!user} onClick={deleteAndClose} color="error">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
